import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '@/contexts/AuthContext';

interface AdminRouteProps {
  element: React.ReactElement;
}

export default function AdminRoute({ element }: AdminRouteProps) {
  const location = useLocation();
  const { user, isAuthenticated, initialized } = useAuthContext();

  if (!initialized) {
    return (
      <div className="min-h-screen bg-sidebar flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <i className="ri-loader-4-line animate-spin text-brand-400 text-3xl" />
          <span className="text-white/40 text-sm font-mono">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  if (user?.role !== 'admin') {
    return <Navigate to="/dashboard?forbidden=admin" replace />;
  }

  return element;
}
